<template>
	<div class="page-container">
		<md-dialog-prompt
		  :md-active.sync="consulta"
		  v-model="numeroBusca"
		  md-title="Buscar Bilhete"
		  md-input-placeholder="Número do Bilhete..."
		  md-cancel-text="Cancelar"
		  md-confirm-text="Buscar"
		  @md-confirm="consultar()" />
		<md-dialog-prompt
		  :md-active.sync="carregarPreAposta"
		  v-model="numeroPreAposta"
		  md-title="Carregar Pré-Aposta"
		  md-input-placeholder="Número da Pré-Aposta..."
		  md-cancel-text="Cancelar"
		  md-confirm-text="Carregar"
		  @md-confirm="carregar()" />
		<md-dialog-alert
		  :md-active.sync="regras"
		  md-title="Regulamento"
		  :md-content="config.system_rules"
		  md-confirm-text="Concordo"
		  @md-confirm="concordoRegras()" />
	  <md-dialog-alert
		  :md-active.sync="alert"
		  :md-content="msgAlert"
		  md-confirm-text="Ok" />
		<md-app md-mode="fixed">
			<md-app-toolbar class="md-primary">
				<md-button class="md-icon-button" @click="menuVisible = !menuVisible" v-bind:class="{ hide: (loadingEvents || isResumeOpened || isDetailOpened) }">
					<md-icon>menu</md-icon>
				</md-button>
				<md-button class="md-icon-button" @click="backHome()" v-bind:class="{ hide: (loadingEvents || !isDetailOpened || isResumeOpened) }">
					<md-icon>arrow_back</md-icon>
				</md-button>
				<md-button class="md-icon-button" @click="toggleResume()" v-bind:class="{ hide: (loadingEvents || !isResumeOpened) }">
					<md-icon>close</md-icon>
				</md-button>
				<div class="md-layout-item md-size-75" style="text-align: center;">
					<span v-bind:class="{ hide: (loadingEvents) }" class="md-title" style="font-size: 15px; font-weight: bold;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;max-width: 240px; margin-left: 0;">
						<img v-bind:class="{ hide: (loadingEvents || isDetailOpened) }" class="titan-logo" src="../assets/logo.png" style="width: 40px; margin-right: 5px; ">
						<span v-bind:class="{ hide: (loadingEvents || !isDetailOpened || isResumeOpened) }">{{ titulo }}</span>
					</span>
				</div>
			</md-app-toolbar>

			<md-app-drawer :md-active.sync="menuVisible">
				<md-toolbar class="md-primary" md-elevation="0" style="border-bottom: 0.8px solid white;">
					<img class="titan-logo" src="../assets/titan_logo.png" style="width: 100px; margin: 10px auto;">
				</md-toolbar>

				<md-list style="padding-top: 0;">
					<md-list-item style="cursor: pointer;" v-if="!loggedIn">
						<md-icon style="color: white;margin-right: 0;">lock</md-icon>
						<span class="md-list-item-text" @click="goToLogin()">Login</span>
					</md-list-item>
					<md-list-item style="cursor: pointer;">
						<md-icon style="color: white;margin-right: 0;">search</md-icon>
						<span class="md-list-item-text" @click="dialogConsulta()">Consultar Bilhete</span>
					</md-list-item>
					<!-- <md-list-item v-if="PIXEnabled()" style="cursor: pointer;">
						<md-icon style="color: white;margin-right: 0;">pix</md-icon>
						<span class="md-list-item-text" @click="dialogSolicitarPix()">Solicitar Prêmio via PIX</span>
					</md-list-item> -->
					<!-- CAMBISTA -->
					<md-list-item style="cursor: pointer; background-color: #CB1323;" v-if="loggedIn">
						<span class="md-list-item-text" @click="dialogConsulta()" style="font-weight: bold;">Bem Vindo, {{ cambista.name }}</span>
					</md-list-item>
					<md-list-item style="cursor: pointer; background-color: #CB1323;" v-if="loggedIn">
						<md-icon style="color: white;margin-right: 0;">move_to_inbox</md-icon>
						<span class="md-list-item-text" @click="dialogPreAposta()">Pré-Aposta</span>
					</md-list-item>
					<md-list-item style="cursor: pointer; background-color: #CB1323;" v-if="loggedIn">
						<md-icon style="color: white;margin-right: 0;">list_alt</md-icon>
						<span class="md-list-item-text" @click="goToMyTickets()">Bilhetes</span>
					</md-list-item>
					<md-list-item style="cursor: pointer; background-color: #CB1323;" v-if="loggedIn">
						<md-icon style="color: white;margin-right: 0;">insert_chart_outlined</md-icon>
						<span class="md-list-item-text" @click="goToMyCashflow()">Caixa</span>
					</md-list-item>
					<md-list-item style="cursor: pointer; background-color: #CB1323;" v-if="loggedIn">
						<md-icon style="color: white;margin-right: 0;">exit_to_app</md-icon>
						<span class="md-list-item-text" @click="logout()">Sair</span>
					</md-list-item>
					<!-- FIM CAMBISTA -->
					<md-list-item style="cursor: pointer;">
						<md-icon style="color: white;margin-right: 0;">android</md-icon>
						<span class="md-list-item-text" @click="goToDownload()">Baixar App</span>
					</md-list-item>
					<!--
					<md-list-item style="cursor: pointer;">
						<md-icon style="color: orange;margin-right: 0;">android</md-icon>
						<span class="md-list-item-text" @click="goToDownload2()">Baixar App Beta</span>
						<md-badge class="md-square" md-content="EM TESTES" />
					</md-list-item> -->
					<md-list-item style="cursor: pointer;">
						<md-icon style="color: white;margin-right: 0;">info</md-icon>
						<span class="md-list-item-text" @click="dialogRegras()">Regulamento</span>
					</md-list-item>
					<md-list-item v-for="dia in diasFiltro" v-bind:key="dia.data" style="cursor: pointer;">
						<span class="md-list-item-text" @click="filter('date', dia.data)">{{ dia.label }}</span>
					</md-list-item>
					<template v-for="pais in paises">
						<md-list-item  style="cursor: pointer;">
							<span v-on:click="setVisibility(pais)" class="md-list-item-text">{{ pais.nome }}</span>
						</md-list-item>
						<md-list-item v-if="pais.visible" v-for="campeonato in pais.campeonatos" v-bind:key="campeonato.id" style="cursor: pointer;">
							<span class="md-list-item-text" style="margin-left: 10px; font-size: 90%;" @click="filter('league', campeonato.id)">{{ campeonato.nome }}</span>
						</md-list-item>
					</template>
					<!-- <md-list-item style="cursor: pointer; margin-bottom: 50px;">
						<md-icon style="color: orange;margin-right: 0;">android</md-icon>
						<span class="md-list-item-text" @click="goToDownload3()">Baixar App Secreto</span>
						<md-badge class="md-square" md-content="ESTOQUE" />
					</md-list-item> -->
				</md-list>
			</md-app-drawer>
			<md-app-content>
				<md-empty-state class="no-event-found"
				md-icon="sentiment_very_dissatisfied" v-if="!loadingEvents && dias.length == 0"
				:md-label="msg"
				md-description="Aguarde, em breve novos jogos estarão disponíveis.">
				</md-empty-state>
				<div class="md-layout md-gutter md-alignment-center-center" v-if="loadingEvents">
					<table>
						<tr>
							<td style="text-align: center;"><img class="titan-logo" src="../assets/loading.gif" style="width: 90px;"> </td>
						</tr>
						<tr>
							<td><img class="titan-logo2" src="../assets/logo_completo.png" style="padding: 40px;max-height: 400px;"> </td>
						</tr>
					</table>
				</div>
				<titan-events style="height: 100%; overflow-y: auto;overflow-x: hidden;padding-bottom: 56px;" v-bind:class="{ hide: (loadingEvents || dias.length <= 0 || isResumeOpened || isDetailOpened) }" :dias="dias" :selected="selected" @select="setSelecteds" @eventDetail="detail($event)"></titan-events>

				<titan-resume v-bind:class="{ hide: (loadingEvents || !isResumeOpened) }" :value="value" :punter="punter" :selected="selected" @updateValue="updateValue($event)" @updatePunter="updatePunter($event)" @clearTicket="clearTicket()" @removeSelected="removeSelected($event)"></titan-resume>

				<titan-detail v-bind:class="{ hide: (loadingEvents || !isDetailOpened || isResumeOpened) }" :eventDetail="eventDetail" :selected="selected" @setSelecteds="setSelecteds($event)"
				></titan-detail>
			</md-app-content>
		</md-app>
		<div class="phone-viewport bottom-bar">
			<md-bottom-bar class="md-accent" md-type="shift">
				<md-bottom-bar-item @click="toggleResume" id="btn-ticket-resume" class="md-size-100 md-small-size-100 btn-ticket-resume" style="max-width: unset !important; font-size: 90%;">
					<div class="md-layout md-gutter ticket-resume-w100">
						<div class="md-layout-item md-size-20" style="line-height: 38px;">Resumo</div>
						<div class="md-layout-item md-size-20 inner-bottom-bar">
							<div class="md-layout" style="height: 20px;line-height: 20px;">
								<div class="md-layout-item">
									{{ qtdEventos }}
								</div>
							</div>
							<div class="md-layout" style="font-size: 80%;">
								<div class="md-layout-item">
									Apostas
								</div>
							</div>
						</div>
						<div class="md-layout-item md-size-45 inner-bottom-bar" style="margin-left: 5px;">
							<div class="md-layout" style="height: 20px;line-height: 20px;">
								<div class="md-layout-item">
									R$ {{ possibleReturn }}
								</div>
							</div>
							<div class="md-layout" style="font-size: 80%;">
								<div class="md-layout-item">
									Retorno
								</div>
							</div>
						</div>
						<div class="md-layout-item md-size-10">
							<md-icon style="font-size: 40px !important;">expand_less</md-icon>
						</div>
					</div>
				</md-bottom-bar-item>
			</md-bottom-bar>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import TitanEvents from './TitanEvents.vue'
	import TitanResume from './TitanResume.vue'
	import TitanDetail from './TitanDetail.vue'
	import TitanLogin from './TitanLogin.vue'
	import TitanMyTickets from './TitanMyTickets.vue'

	export default {
		name: 'TitanHome',
		components: {
			TitanEvents, TitanResume, TitanDetail, TitanLogin, TitanMyTickets
		},
		data () {
			return {
				titulo: 'Futebol',
				isResumeOpened: false,
				isDetailOpened: false,
				consulta: false,
				regras: false,
				numeroBusca: "",
				diasFiltro: [],
				paises: [],
				config: {},
				menuVisible: false,
				loadingFilters: true,
				loadingEvents: true,
				dias: [],
				selected: [],
				msg: "",
				qtdEventos: 0,
				multiplier: 1,
				punter: "",
				value: 0.00,
				possibleReturn: 0.00,
				eventDetail: [],
				alert: false,
				msgAlert: "",
				loggedIn: false,
				carregarPreAposta: false,
				numeroPreAposta: "",

			}
		},
		methods: {
			PIXEnabled: function(){
                return this.$root.$data.PIX;
            },
            dialogSolicitarPix: function() {
                this.msgAlert = "Para solicitar o prêmio de um bilhete realizado via PIX entre em contato por WhatsApp através do número <b><a href=\"https://wa.me/55" + this.$root.$data.SUPORTE_PIX.match(  /\d+/g ).join("") + "?text=Gostaria%20de%20solicitar%20o%20saque%20de%20um%20premio!\">" + this.$root.$data.SUPORTE_PIX + "</a></b>.";
                this.alert = true
            },
			setup: function() {
				for (let i = 0; i < this.paises.length; i++) {
					let pais = this.paises[i];
					pais.visible = false;
					this.paises.splice(i, 1, pais);
				}
			},
			setVisibility: function(pais) {
				for (let i = 0; i < this.paises.length; i++) {
					if (this.paises[i].nome == pais.nome) {
						pais.visible = !pais.visible;

						this.paises.splice(i, 1, pais);
					}
				}
			},
			setSelecteds: function(selected) {
				this.selected = selected
				this.refreshBottomBar()
			},
			toggleResume: function() {
				this.isResumeOpened = !this.isResumeOpened
				this.changeTitle();
			},
			backHome: function(){
				this.isDetailOpened = false
				this.isResumeOpened = false
				this.changeTitle()
			},
			changeTitle: function(){
				if (this.isResumeOpened) this.titulo = 'Resumo'
				else if (this.isDetailOpened) this.titulo = this.eventDetail.nomeEvento
				else this.titulo = 'Futebol'
			},
			refreshBottomBar: function() {
				this.qtdEventos = this.selected.length

				var pr;
				var max_quote = parseFloat(this.config.max_quote)
				var top_prize = parseFloat(this.config.top_prize)
				var value = parseFloat(this.value)

				if (this.qtdEventos <= 0) {
					pr = 0.0.toFixed(2)
				}
				else {
					this.multiplier = 1;
					for (let i = 0; i < this.qtdEventos; i++) {
						this.multiplier = this.multiplier * this.selected[i].cotacao
					}

					pr = (this.multiplier * this.value).toFixed(2)
				}

				pr = parseFloat(pr)

				if (pr > value * max_quote) {
					this.msgAlert = "Cotação máxima de " + max_quote + " vezes o valor apostado foi atingida."
					pr = value * max_quote
					this.alert = true
				}

				if (parseFloat(pr) > top_prize) {
					this.msgAlert = "O limite de premiação de " + top_prize + " foi atingido."
					pr = top_prize
					this.alert = true
				}

				this.possibleReturn = pr
			},
			removeSelected: function(subevento) {
				for (let i = 0; i < this.selected.length; i++) {
					if (this.selected[i].id == subevento.id) {
						this.selected.splice(i, 1);
						break;
					}
				}
				this.refreshBottomBar()
			},
			updatePunter: function(punter) {
				this.punter = punter
			},
			updateValue: function(value) {
				this.value = value
				this.refreshBottomBar();
			},
			clearTicket: function() {
				this.selected = []
				this.refreshBottomBar()
			},
			filter: function(type, param) {
				this.loadingEvents = true;
				this.menuVisible = false
				this.dias = []
				axios
				.get(this.$root.$data.API_URL + 'events/' + type + '/' + param)
				.then(response => {
					if (response.data.success) {
						this.buildDias(response.data.result.eventos)
					} else this.msg = response.data.message
				})
				.finally(() => this.loadingEvents = false );
			},
			detail: function(eventDetail) {
				this.eventDetail = eventDetail;
				this.isDetailOpened = true;
				this.changeTitle()
			},
			dialogConsulta: function() {
				this.menuVisible = false
				this.consulta = true
			},
			dialogRegras: function() {
				this.menuVisible = false
				this.regras = true
			},
			dialogPreAposta: function() {
				this.menuVisible = false
				this.carregarPreAposta = true
			},
			consultar: function() {
				if (this.numeroBusca != "") {
					this.$router.push({ name: 'TitanReprint', params: { id: this.numeroBusca }})
				}
			},
			goToLogin: function() {
				this.$router.push({ name: 'TitanLogin' })
			},
			concordoRegras: function() {
				this.regras = false
			},
			goToDownload: function() {
				window.location = "https://app.esportemania.info/download_esportemania.php"
			},
			buildDias: function(data) {
				this.dias = Object.keys(data).map((key) => {
					return data[key]
				});

				this.dias[0].campeonatos = Object.keys(this.dias[0].campeonatos).map((key) => {
					return this.dias[0].campeonatos[key];
				});

				this.dias[0].campeonatos.sort(function(a, b) {
					if (a.nome > b.nome) return 1;
					else if (a.nome < b.nome) return -1;
					else return 0;
				})

				var mains = []
				var normals = []
				for (let i = 0; i < this.dias[0].campeonatos.length; i++) {
					if (this.dias[0].campeonatos[i].main == 's') mains.push(this.dias[0].campeonatos[i])
					else normals.push(this.dias[0].campeonatos[i])
				}

				for (let i = 0; i < normals.length; i++) {
					mains.push(normals[i])
				}
				this.dias[0].campeonatos = mains
			},
			logout: function() {
				this.$store.commit('LOGOUT')
				this.loggedIn = false
			},
			goToMyTickets: function() {
				this.$router.push({ name: 'TitanMyTickets' })
			},
			goToMyCashflow: function() {
				this.$router.push({ name: 'TitanCashflow' })
			},
			carregar: function() {
				if (this.numeroPreAposta != "") {
					let pre = {}
					pre.number = this.numeroPreAposta

					var form = new FormData();
					form.append("data", JSON.stringify(pre));

					var config = {
					  headers: {'Content-Type': 'application/x-www-form-urlencoded', Authorization: 'Bearer  ' + this.$store.state.usuario.token}
					};

					let v = this
					//seller/loadprebet
					axios.post(this.$root.$data.API_URL + 'seller/loadprebet', form, config)
					.then(function (response) {
						//console.log(response.data);
						let result = response.data
						if (result.success) {
							let subevents = []
							let bet_odds = result.result.bet_odds
							for (let i = 0; i < bet_odds.length; i++) {
								let s1 = bet_odds[i]

								let subevento = {}
								subevento.aposta = s1.name
								subevento.cotacao = s1.price
								subevento.dia = s1.schedule
								subevento.fulllabel = s1.name
								subevento.id = s1.id
								subevento.idOpcao = s1.idOption
								subevento.label = s1.label
								subevento.nome = s1.label
								subevento.titulo = s1.title

								subevento.evento = {}
								subevento.evento.casa = s1.home
								subevento.evento.fora = s1.out
								subevento.evento.horario = ""

								subevents.push(subevento)
							}

							v.updatePunter(result.result.punter)
							v.updateValue(result.result.value)
							v.setSelecteds(subevents)
							v.isResumeOpened = true
						} else {
							v.msgAlert = result.message
							v.alert = true
						}
					})
				}
				else {
					this.msgAlert = "Número da pré-aposta inválido."
					this.alert = true
				}
			}
		},
		mounted() {

			if (this.$store.state.usuario) {
				this.loggedIn = true
			}

			this.refreshBottomBar();

			axios
			.get(this.$root.$data.API_URL + 'events')
			.then(response => {
				if (response.data.success) {
					this.buildDias(response.data.result.eventos)
				} else this.msg = response.data.message
			})
			.finally(() => this.loadingEvents = false );

			axios
			.get(this.$root.$data.API_URL + 'filters')
			.then(response => {
				if (response.data.success) {
					this.diasFiltro = response.data.result.dias.filtros
					this.paises = response.data.result.campeonatos.modalidades['0'].paises
					this.config = response.data.result.configs
				}
			}).finally(() => this.setup() );
		},
		computed: {
			cambista: function () {
			  return this.$store.state.usuario
			}
		}
	}
</script>

<style lang="scss" scoped>
@import "~vue-material/dist/theme/engine"; // Import the theme engine

@include md-register-theme("default", (
	primary: #000000, // The primary color of your brand
	accent: #CB1323 // The secondary color of your brand
	));

@import "~vue-material/dist/theme/all"; // Apply the theme
</style>



// WEBPACK FOOTER //
// src/components/TitanHome.vue